import { css } from 'styled-components'

export const focusable = css`
  &:focus-visible {
    outline: 2px solid var(--primary-color);
    border-radius: 0.3rem;
  }
`

export const resetButtonStyle = css`
  all: unset;
  ${focusable}
`
